import { render, staticRenderFns } from "./Headportrait.vue?vue&type=template&id=27e230e2"
import script from "./Headportrait.vue?vue&type=script&lang=js"
export * from "./Headportrait.vue?vue&type=script&lang=js"
import style0 from "./Headportrait.vue?vue&type=style&index=0&id=27e230e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports